import Lightbox from '~/app/elements/Lightbox';
import getDetailsContent from '~/app/utils/getDetailsContent';
import getClosestByTagName from '~/utils/nodes/getClosestByTagName';

const detailsWithLoadedImages = new WeakSet<HTMLElement>();

/**
 * Карточки интерьеров квартир.
 */
function main(): void
{
	const sectionsContainer = document.querySelector( 'main>div.sections' );
	
	if ( !sectionsContainer )
	{
		return;
	}
	
	sectionsContainer.addEventListener( 'click', onSectionClick );
}

function onSectionClick( event: Event ): void
{
	const article = getClosestByTagName( event.target as Element, 'SECTION' );
	
	if ( !article )
	{
		return;
	}
	
	const details = article.querySelector( 'section>details' ) as HTMLElement;
	
	if ( !details )
	{
		return;
	}
	
	if ( !detailsWithLoadedImages.has( details ) )
	{
		detailsWithLoadedImages.add( details );
		loadImages( details );
	}
	
	const lightbox = Lightbox.instance;
	
	event.preventDefault();
	lightbox.open( getDetailsContent( details ) );
}

function loadImages( container: Element ): void
{
	const links = container.querySelectorAll( 'ul.images>li>a' ) as
		NodeListOf<HTMLAnchorElement>;
	
	for ( let i = 0, n = links.length; i < n; i++ )
	{
		replaceLinkToImage( links[i] );
	}
}

function replaceLinkToImage( link: HTMLAnchorElement ): void
{
	const parent = link.parentNode;
	const href = link.getAttribute( 'href' );
	
	if ( !parent || !href )
	{
		return;
	}
	
	const image = new Image();
	
	image.alt = link.textContent || '';
	image.src = href;
	
	parent.replaceChild( image, link );
}

/**
 * Module.
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Decoration/Sections/index.ts